// extracted by mini-css-extract-plugin
export default {"wrap":"GI-z","fullWidth":"HI-z","hideOnDesktop":"II-z","content":"JI-z","hasOpenedNav":"KI-z","crumbsList":"LI-z","dropdownsWrap":"MI-z"};